import {useTimer} from '@rocket-ui/react-tools';
import {useResendLoginCode, useResendRecoveryCode} from '@rocket-ui/lk-api';
import React, {FC, useCallback, useEffect} from 'react';

const TIMER_ID = 'authorization-code-timer';
const RECOVERY_TIMER_ID = 'recovery-authorization-code-timer';
const TIMER_DURATION_SECONDS = 60;

interface AuthorizationCodeTimerProps {
	token: string;
	/** Для повторной отправки кода через тот же канал (например Telegram). */
	resendOtpStrategy?: string | null;
	recovery?: boolean;
}

export const AuthorizationCodeTimer: FC<AuthorizationCodeTimerProps> = ({token, resendOtpStrategy, recovery}) => {
	const {mutateAsync: resendLoginCode} = useResendLoginCode();
	const {mutateAsync: resendRecoveryCode} = useResendRecoveryCode();
	const {seconds, result, onReset} = useTimer(recovery ? RECOVERY_TIMER_ID : TIMER_ID, TIMER_DURATION_SECONDS);

	useEffect(() => {
		onReset();
	}, [onReset]);

	const handleRequestSms = useCallback(
		async (e: React.MouseEvent<HTMLDivElement>) => {
			e.preventDefault();
			const request = {
				token,
				...(resendOtpStrategy ? {otp_strategy: resendOtpStrategy} : {}),
			};

			if (recovery) {
				await resendRecoveryCode(request);
			} else {
				await resendLoginCode(request);
			}

			onReset();
		},
		[onReset, recovery, resendLoginCode, resendRecoveryCode, resendOtpStrategy, token],
	);

	if (seconds > 0) {
		return (
			<p className={'text-center text-sm text-skin-muted max-sm:w-full sm:text-left'}>
				Запросить код заново можно через {result}
			</p>
		);
	}

	return (
		<div
			onClick={handleRequestSms}
			className={
				'cursor-pointer text-base font-medium max-sm:block max-sm:w-full max-sm:border-0 max-sm:bg-black max-sm:py-4 max-sm:text-center max-sm:text-white max-sm:no-underline sm:inline sm:w-auto sm:bg-transparent sm:py-0 sm:text-black sm:no-underline'
			}
		>
			Получить новый код
		</div>
	);
};
